import ContactsIcon                from '@/assets/icons/ContactsIcon';
import List                        from '@/components/list/List';
import ContactModel                from '@/models/services/network/ContactModel';
import ContactListRow              from './ContactListRow';
import { useTranslation }          from 'react-i18next';
import RelationRequestModel        from '@/models/services/network/RelationRequestModel';
import RelationRequestStatusModel  from '@/models/services/network/RelationRequestStatusModel';
import authStore                   from '@/stores/authStore';
import { ModalData }               from '@/components/modal/Modal';
import RelationContactModel        from '@/models/services/network/RelationContact';
import FileModel                   from '@/models/services/file/FileModel';
import RelationStatusModel         from '@/models/services/network/RelationStatus';
import React                       from 'react';
import usePagedCollection          from '@widesk-core/hooks/usePagedCollection';
import useApiCollection            from '@widesk-core/hooks/useApiCollection';

interface IContactsListBoxProps {
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	fetchRef?: React.MutableRefObject<(() => Promise<void>) | undefined>
}

const ContactsListBox = (props: IContactsListBoxProps) => {

	const { setModalData, setModalIsOpen, fetchRef } = props;

	const contactCollection = usePagedCollection(ContactModel);
	const fileCollection = useApiCollection(FileModel);
	const relationContactCollection = useApiCollection(RelationContactModel);
	const relationRequestCollection = useApiCollection(RelationRequestModel);
	const relationRequestStatusCollection = useApiCollection(RelationRequestStatusModel);
	const relationStatusCollection = useApiCollection(RelationStatusModel);
	
	const { t } = useTranslation();

	return (
		<List
			afterFetch={async () => {
				const contactsIds = contactCollection.map(m => m.id);
				const contactsUrns = contactCollection.map(m => m.urn);

				await Promise.all([
					relationRequestCollection.listBy(contactsIds, 'contact'),
					fileCollection.setFilter('typeSource.type.reference', 'contact_photo').setSort('createdAt', 'desc').listBy(contactsUrns, 'typeSource.source.entityUrn'),
					relationContactCollection.list(),
				]);
				await Promise.all([
					relationRequestCollection.whenIsLoaded(m => m.relationRequestStatus),
					fileCollection.whenIsLoaded(m => m.typeSource.source),
					relationContactCollection.whenIsLoaded(m => m.relation),
				]);
			}}
			beforeFetch={async () => {
				contactCollection.setSort('firstname', 'asc').setFilter('ownerUser.userUrn', authStore.currentUser.urn);
				await Promise.all([
					relationRequestStatusCollection.list(),
					relationStatusCollection.list(),
				]);
			}}
			collection={contactCollection}
			renderRow={(model) => {
				return <ContactListRow 
					contact={model}
					contactCollection={contactCollection}
					fileCollection={fileCollection}
					relationRequestCollection={relationRequestCollection}
					relationRequestStatusCollection={relationRequestStatusCollection}
					relationContactCollection={relationContactCollection}
					relationStatusCollection={relationStatusCollection}
					setModalData={setModalData}
					setModalIsOpen={setModalIsOpen}
				/>
			}}
			getFetch={fetch => {
				if (fetchRef) {
					fetchRef.current = fetch;
				}
			}}
			options={{
				emptyMessages: {
					title: t('pages.contacts.list.empty.title'),
					description: t('pages.contacts.list.empty.description'),
					icon: <ContactsIcon size="xl" />,
				},
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withSeparators: true,
			}}
		/>
	);
}

export default ContactsListBox;